import { render, staticRenderFns } from "./OverviewGeneral.vue?vue&type=template&id=a3103a5a"
import script from "./OverviewGeneral.vue?vue&type=script&lang=ts"
export * from "./OverviewGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports